import { useEffect, useState } from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { buildWhatsAppUrl } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function StickyMobileCTAs() {
  const [hideInsideForm, setHideInsideForm] = useState(false);

  useEffect(() => {
    const target = document.getElementById("cotiza");
    if (!target) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => setHideInsideForm(e.isIntersecting));
      },
      { threshold: 0.25 }
    );
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  if (hideInsideForm) return null;

  return (
    <div
      className="md:hidden fixed inset-x-0 bottom-0 z-40 flex h-14 bg-eclipse-900/95 backdrop-blur border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,0.4)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="sticky-mobile-ctas"
    >
      <a
        href={buildWhatsAppUrl("Hola, vengo del sitio web y me interesa cotizar una velaria.")}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent("cta_whatsapp_click", { location: "sticky_mobile" })}
        className="flex-1 flex items-center justify-center gap-2 text-white font-display font-bold uppercase text-[11px] tracking-wider"
        style={{ background: "#25D366" }}
        data-testid="sticky-mobile-whatsapp"
      >
        <MessageCircle className="w-4 h-4" /> Cotiza por WhatsApp
      </a>
      <button
        onClick={() => {
          trackEvent("cta_quote_click", { location: "sticky_mobile" });
          const el = document.getElementById("cotiza");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }}
        className="flex-1 flex items-center justify-center gap-2 bg-accent text-white font-display font-black uppercase text-[11px] tracking-wider"
        data-testid="sticky-mobile-quote"
      >
        Cotiza gratis <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
